import type { ReleaseNoteCategory, ReleaseNoteEntry } from './versionApi';

export const RELEASE_NOTE_CATEGORY_ORDER: readonly ReleaseNoteCategory[] = ['new', 'improved', 'fixed'];

export interface LocalizedReleaseNote {
  readonly id: string;
  readonly title: string;
  readonly body: string | null;
  readonly actionRequired: boolean;
  readonly date: string;
}

export interface ReleaseNoteGroup {
  readonly category: ReleaseNoteCategory;
  readonly notes: readonly LocalizedReleaseNote[];
}

/** English for an English UI, Finnish otherwise (Finnish is the source language). */
export function localizeReleaseNote(entry: ReleaseNoteEntry, language: string): LocalizedReleaseNote {
  const text = language.toLowerCase().startsWith('en') ? entry.en : entry.fi;
  return {
    id: entry.id,
    title: text.title,
    body: text.body ?? null,
    actionRequired: entry.actionRequired,
    date: entry.date,
  };
}

/** New / Improved / Fixed, in that order, empty groups left out. Entry order is kept. */
export function groupReleaseNotes(
  entries: readonly ReleaseNoteEntry[],
  language: string,
): ReleaseNoteGroup[] {
  return RELEASE_NOTE_CATEGORY_ORDER.map((category) => ({
    category,
    notes: entries
      .filter((entry) => entry.category === category)
      .map((entry) => localizeReleaseNote(entry, language)),
  })).filter((group) => group.notes.length > 0);
}
